import androidAppSrc from 'assets/images/mobileApp/downloadAndroid.webp';
import { ImageComponent } from 'components/Image';
import { isIos } from 'helpers/common';
import { MobileAppContext } from 'modules/mobileApp/context';
import { useContext } from 'react';
import { Link } from 'react-navi';

interface IDownloadAndroidAppProps {
  onClick?: () => void;
  width?: number;
  height?: number;
  download?: boolean;
}

export const DownloadAndroidApp = ({
  onClick,
  width,
  height,
  download,
}: IDownloadAndroidAppProps) => {
  const { data } = useContext(MobileAppContext);

  if (!(data && data.androidApk) || isIos()) return null;

  const { androidApk } = data;

  return (
    <Link
      className="button"
      href={download ? androidApk.url : '/mobile-app'}
      onClick={onClick}
    >
      <ImageComponent
        alt="Google Play link"
        className="button-download"
        height={height || 48}
        src={androidAppSrc}
        width={width || 144}
      />
    </Link>
  );
};
